import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Bus, ClipboardList, QrCode, LogOut, Wifi, WifiOff, CloudUpload } from "lucide-react";
import { Toaster } from "sonner";
import { useOfflineQueue } from "@/lib/offlineQueue";
import HelpButton from "@/components/HelpButton";
import NotificationBell from "@/components/NotificationBell";

export default function DriverLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pending, online, flushNow } = useOfflineQueue();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Toaster position="top-center" richColors closeButton />

      <header className="sticky top-0 z-40 bg-zinc-900 text-white border-b border-zinc-900">
        <div className="px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#FFC60A] flex items-center justify-center">
              <Bus size={16} className="text-zinc-900" />
            </div>
            <div>
              <div className="font-display font-black text-base tracking-tighter">LOGIBUS</div>
              <div className="text-[9px] font-mono tracking-[0.25em] uppercase text-[#FFC60A]">Chauffeur</div>
            </div>
          </div>
          <div className="text-right flex items-center gap-3">
            <NotificationBell testId="driver-notif-bell" />
            <button onClick={flushNow} data-testid="driver-sync-status"
              title={online ? "Connecté" : "Hors-ligne"}
              className={`inline-flex items-center gap-1 px-2 py-1 text-[10px] font-mono tracking-widest uppercase border ${online ? "bg-green-500 border-green-700 text-white" : "bg-red-500 border-red-700 text-white"}`}>
              {online ? <Wifi size={11} /> : <WifiOff size={11} />}
              {pending > 0 ? <span className="inline-flex items-center gap-1"><CloudUpload size={10} /> {pending}</span> : (online ? "OK" : "OFF")}
            </button>
            <div>
              <div className="text-xs font-semibold">{user?.name}</div>
              <div className="text-[9px] font-mono tracking-[0.2em] uppercase text-zinc-400" data-testid="driver-tenant-name">{user?.tenant?.name}</div>
              <button data-testid="driver-logout-button" onClick={async () => { await logout(); navigate("/login"); }}
                className="text-[10px] font-mono tracking-widest uppercase text-zinc-300 hover:text-[#FFC60A] inline-flex items-center gap-1">
                <LogOut size={11} /> Sortir
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="flex-1 pb-20">
        <Outlet />
        <HelpButton offsetBottom="bottom-20" />
      </main>

      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-zinc-900 grid grid-cols-2" data-testid="driver-bottom-nav">
        <NavLink to="/driver" end data-testid="driver-nav-missions" className={({ isActive }) =>
          `py-3 text-xs font-bold uppercase tracking-widest flex items-center justify-center gap-2 ${isActive ? "bg-[#FFC60A]" : "bg-white"}`}>
          <ClipboardList size={16} /> Missions
        </NavLink>
        <NavLink to="/driver/scan" data-testid="driver-nav-scan" className={({ isActive }) =>
          `py-3 text-xs font-bold uppercase tracking-widest flex items-center justify-center gap-2 border-l border-zinc-900 ${isActive ? "bg-[#FFC60A]" : "bg-white"}`}>
          <QrCode size={16} /> Scan
        </NavLink>
      </nav>
    </div>
  );
}
